import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';

import Utility from '../../../util/utilityfunctions';

const StackedBarChart = ({
	series = [],
	min = 0,
	max = null,
	roundDecimal = 0,
	onGraphicClick = null,
	tooltipFormatter = null
}) => {
	const numberFormat = useSelector(({userPreferences}) => userPreferences.numberFormat);

	const options = {
		chart: {
			backgroundColor: 'transparent',
			type: 'bar',
			margin: 0,
			padding: 0,
			height: 40
		},
		title: {
			text: ''
		},
		xAxis: {
			visible: false,
			endOnTick: false
		},
		yAxis: {
			visible: false,
			endOnTick: false,
			reversed: false,
			maxPadding: 0,
			min,
			max
		},
		legend: {
			verticalAlign: 'top',
			layout: 'vertical',
			x: -40,
			y: 100,
			margin: 0,
			reversed: true,
			itemMarginBottom: 0,
			itemStyle: {
				color: '#000',
				fontSize: '1.6rem'
			},
			symbolPadding: 0,
			navigation: {
				enabled: false
			}
		},
		credits: {
			enabled: false
		},
		plotOptions: {
			series: {
				stacking: 'normal',
				states: {
					hover: {
						enabled: false
					}
				},
				borderWidth: 2,
				borderColor: 'var(--neutrals-25)',
				point: {
					events: {
						click: (e) => {
							onGraphicClick && onGraphicClick(e);
						}
					}
				}
			}
		},
		tooltip: {
			useHTML: true,
			enabled: true,
			outside: true,
			followPointer: true,
			formatter: function(v) {
				if (tooltipFormatter) return tooltipFormatter(numberFormat, this);
				return `<span class="motif-body2-default-light">${this.series.name} | ${Utility.getFormattedNumber(
					numberFormat,
					this.y
				)} (${Highcharts.numberFormat(this.percentage, roundDecimal)}%)</span>`;
			}
		},
		accessibility: {
			point: {
				valueSuffix: '%'
			}
		},
		exporting: {
			enabled: false
		},
		series
	};

	return (
		<StyledStackedBarChart>
			<HighchartsReact highcharts={Highcharts} options={options} />
		</StyledStackedBarChart>
	);
};

StackedBarChart.propTypes = {
	series: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			data: PropTypes.arrayOf(PropTypes.any),
			color: PropTypes.string
		})
	),
	min: PropTypes.number,
	max: PropTypes.number,
	numberFormat: PropTypes.number,
	roundDecimal: PropTypes.number,
	onGraphicClick: PropTypes.func,
	tooltipFormatter: PropTypes.func
};

export default StackedBarChart;

const StyledStackedBarChart = styled.div`
	width: 100%;
`;
